module.exports = __webpack_public_path__ + "img/class-title-icon2.20139daa.png";